import React from 'react';
import PropTypes from 'prop-types';
import {Screen} from '../Screen';
import PulseIcon from '@learningblocks/exp-constants/lib/Images/mc_settings_pulse.svg';
import {Image} from '@learningblocks/storybook-components';
import {Input} from '../Input';

import './style.scss';

export function RPMDisplay(props) {
  return (
    <Screen className='mc_settings_rpmDisplay'>
      <div className='mc_settings_rpmDisplay_inputBlock'>
        <Input
          className='mc_settings_rpmDisplay_inputBlock_input'
          value={props.displayValue}
          setValue={props.setRPM}
          ariaLabel={`RPM input. Current RPM set at ${props.displayValue} RPM.`}
        />
        <Image
          className='mc_settings_rpmDisplay_inputBlock_pulseIcon'
          src={PulseIcon}
        />
      </div>
    </Screen>
  );
}

RPMDisplay.propTypes = {
  /**
   * value to be displayed in rpm display
   */
  displayValue: PropTypes.number,
  /**
   * value to be displayed in RPM display
   */
  displayValue: PropTypes.number,
  /**
   * callback function to set the value of ROM
   */
  setRPM: PropTypes.func,
};

RPMDisplay.defaultProps = {
  displayValue: 0,
};
